export default "__VITE_ASSET__Cc7hkjQb__"